<template>
	<div class="box">
		<div class="top">
			<div class="title">Grupos</div>
			<button v-if="props.item.length > 2" @click="show = !show">Ver mais</button>
		</div>
		<div class="content" v-if="props.item?.length > 0">
			<div class="boxLine" v-for="(g, index) in props.item?.slice(0, 2)" :key="index">
				<div class="icon" :style="{backgroundImage: 'url(https://habblet.city/habblet-imaging/badge/'+g.badgeCode+')'}"></div>
				<div class="flex">
					<div>
						<div class="text">{{g.name}}</div>
						<div class="text">{{g.description}}</div>
					</div>
					<div class="boxInfo">
						<div class="info">ID do quarto: <a class="black block hover:text-blue-900" :href="`https://www.habblet.city/room/${g.roomId}`" target="_blank">{{g.roomId}}</a></div>
<!--						<div class="info">Dono: <span>{{g.owner}}</span></div>-->
<!--						<div class="info">Membro: <span>{{g.level}}</span></div>-->
<!--						<div class="info">Entrou em: <span>{{new Date(g.joined * 1000).toLocaleDateString()}}</span></div>-->
<!--						<div class="info">Grupo criado em: <span>{{new Date(g.created * 1000).toLocaleDateString()}}</span></div>-->
					</div>
				</div>
			</div>
		</div>
	</div>
	<ModGroups v-if="show" :item="props.item" @close="show = !show" />
</template>

<script setup>
import ModGroups from './ModGroups.vue'
import { ref } from 'vue'

const props = defineProps({
  item: {
    type: [Array, Object],
    default: () => []
  }
})
const show = ref(false)
</script>

<style scoped>


.box {
	float: left;
	width: 100%;
	position: relative;
	margin-top: 16px;
	background-color: #f1f1f1;
	border-radius: 12px;
}

.box .top {
	position: relative;
	width: 100%;
	height: 20px;
	display: flex;
	justify-content: space-between;
}

.box .top .title {
	width: 10%;
	height: 20px;
	margin: 15px 0 0 16px;
	color: #444;
	font-size: 14px;
	font-weight: 600;
}

.box .top button {
	float: left;
	width: auto;
	height: 36px;
	background-color: #fff;
	border-radius: 20px;
	text-align: center;
	line-height: 36px;
	font-size: 14px;
	font-weight: 600;
	color: #505F6C;
	padding: 0 16px;
	margin: 8px 8px 0 0;
	user-select: none;
	cursor: pointer;
	transition: all .3s ease;
}
.box .top button:hover {background-color: var(--color1);color: #fff;border-color: #fff;}

.box .content {
	position: relative;
	width: 100%;
	height: auto;
	padding: 10px;
	display: flex;
	justify-content: space-around;
	flex-flow: wrap;
	box-shadow: none;
	border-top: 0;
	background-color: transparent;
}

.box .content .boxLine {
	width: 100%;
	height: auto;
	padding: 10px;
	background-color: #fff;
	border-radius: 12px;
	margin-top: 6px;
	display: flex;
	justify-content: space-around;
	transition: all .3s ease;
}
.box .content .boxLine:hover {background-color: var(--color1);border-color: transparent;color: #fff;}

.box .content .boxLine .icon {
	position: relative;
	width: 60px;
	height: 60px;
	top: 50%;
	transform: translateY(-50%);
	background-position: center;
	background-repeat: no-repeat;
}

.box .content .boxLine .flex {
	width: 70%;
	display: flex;
	justify-content: space-between;
}

.box .content .boxLine .flex .text {
	width: 100%;
	height: auto;
	padding: 4px 0;
	margin-top: 4px;
	font-size: 14px;
	font-weight: 600;
}
.box .content .boxLine .flex .text:last-of-type {font-size: 13px;font-weight: 400;}

.box .content .boxLine .flex .info {
	font-size: 12px;
	margin-top: 2px;
}
.box .content .boxLine .flex .info span {font-weight: 600;}
</style>